<template>
  <div id='choose'>
    <div class="container">
      <div class="container__liner">
        <div id="navigaton">
          <div class="breadcrumbs">
            <a href='/' class="breadcrumbs-item">Главная</a>
            <span class="breadscrumbs-item" >Подобрать товар по модели авто</span>
          </div>
        </div>
        <div class="title">
            <h1 id="pagetitle" class="entry">
              <span>{{ pageH1 }}</span>
            </h1>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="container__liner">
        <div class="stock">
          <form>
            <widget-select
              :button="false"
              @selection="selection = $event"
            />
          </form>
          <choose-table
            v-if="data && !loading"
            :initData="data"
          />
          <div v-else-if="loading" class="loader loader-catalog-list">
            <div class="box box-flex" style="margin-bottom: 50px">
              <div class="item load-skeleton" style="height: 75px"></div>
              <div class="item load-skeleton" style="height: 400px"></div>
              <div class="item load-skeleton" style="height: 400px"></div>
            </div>
          </div>
          <Feedback :partner="true" />
        </div>
      </div>
    </div>
    <widget-map />
  </div>
</template>

<script>
import WidgetSelect from '../components/WidgetSelect'
import ChooseTable from '../components/ChooseTable'
import Feedback from "../components/Feedback"
import WidgetMap from '../components/WidgetMap'
import { fetchSelectionProducts } from '../api/adminBrands'
import { metaFromSeoOrDefaults } from '../seo/metaFromStore'

export default {
  components: {
    WidgetSelect,
    ChooseTable,
    Feedback,
    WidgetMap
  },
  computed: {
    pageH1() {
      const s = this.$store.state.seoPage
      if (s && s.id && s.h1) {
        return s.h1
      }
      return 'Подобрать товар по модели авто'
    },
  },
  data() {
    return {
      selection: null,
      data: null,
      loading: false,
    }
  },
  watch: {
    selection(value) {
      if (value && value.make && value.model && (value.car_info_id || value.body || value.set_title)) {
        this.getInitDataSelection()
      }
    }
  },
  methods: {
    async getInitDataSelection() {
      this.data = null
      this.loading = true
      try {
        this.data = await fetchSelectionProducts(this.selection)
      } catch (e) {
        this.data = []
      }
      this.loading = false
    },
  },
  metaInfo() {
    return metaFromSeoOrDefaults(this.$store, {
      title: 'Подобрать товар по модели авто',
    })
  },
}
</script>